<div [formGroup]="formGroup" class="fullWidth margin-b_one">
  <mat-form-field appearance="outline">
    <mat-label>Number</mat-label>
    <input matInput [placeholder]="placeholder" [mask]="mask" formControlName="integer">
  </mat-form-field>
</div>
